module.exports = __webpack_public_path__ + "img/hrvoje_miter.2af2c197.jpg";